import styled, { css } from 'styled-components';
import { Button } from '@/components/Button';

export const Container = styled.div`
  width: 100%;
  max-width: 330px;
  padding: 24px;
  background: var(--white);

  @media (width >= 48rem) {
    width: 330px;
    max-width: calc(100vw - 32px);
  }
`;

export const ToastHeading = styled.div<{ $isError: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;
  padding-block-end: 16px;
  border-bottom: 1px solid var(--grey-200);
  color: ${props => (props.$isError ? 'var(--error-600)' : 'var(--black)')};

  & .icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 56px;
    min-width: 56px
    height: 56px;
    aspect-ratio: 1 / 1;
    background: ${props => (props.$isError ? 'var(--error-100)' : 'var(--success-100)')};
    border: 10px solid ${props => (props.$isError ? 'var(--error-50)' : 'var(--success-50)')};
    border-radius: 28px;

    & svg {
      width: 28px;
      height: 28px;
      stroke: ${props => (props.$isError ? 'var(--error-600)' : 'var(--success-600)')};
    }
  }

  & > div:not(.icon) {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
`;

export const ProductDetailsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;
  padding-block: 16px;
`;

export const Thumbnail = styled.div`
  width: 92px;
  height: 74px;
  padding: 4px 5px;
  background:  var(--grey-50);
  border: 1px solid var(--grey-200);
  border-radius: var(--radius-base);
  position: relative;
  container-type: inline-size;

  & img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const ProductDetails = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
`;

const sharedDetails = css`
  font-size: var(--font-size-text-md);
  font-weight: var(--font-weight-semibold);
  line-height: 24px;
  color: var(--black)
`;

export const ProductName = styled.div`
  ${sharedDetails}
`;

export const Author = styled.div`
  font-size: var(--font-size-text-sm);
  font-weight: var(--font-weight-semibold);
  line-height: 20px;
  color: var(--grey-500);
`;

export const Price = styled.div`
  ${sharedDetails};
`;

export const DismissButton = styled(Button)`
  justify-self: center;
  margin-block-start: var(--spacing-large);
`;
